import React from "react"
import Text from "aldoo-ra/Text"
import Typography from "aldoo-ra/Typography"
import MenuGroup from "aldoo-ra/MenuGroup"
import Value from "aldoo-ra/Value"
import FeatureCard from "./FeatureCard"
import CompactAdminHome from "./CompactAdminHome"
import UserProfileButton from "./UserProfileButton"

const Admin = () => {
  const [updates] = Value("site-updates")
  const [useCompactLayout] = Value("admin-compact-layout", true) // Default to compact layout


  // Use compact layout by default
  if (useCompactLayout) {
    return <CompactAdminHome />
  }

  // Original layout (fallback)
  return (
    <div className="min-h-screen bg-admin_paper p-8 relative">
      {/* Top Right Controls */}
      <div className="absolute top-8 right-8 flex items-center justify-center gap-4 flex-shrink-0 z-20">
        {/* User Profile Button */}
        <UserProfileButton />
      </div>

      <div className="max-w-6xl mx-auto">
        <Text
          id="site_name"
          variant="admin_h1"
          className="text-center mb-2"
          fallback="Admin Panel"
        />

        <Typography
          component="h2"
          variant="admin_h4"
          className="text-center text-admin_text_secondary font-normal mb-12"
        >
          Site Features
        </Typography>
        
        <MenuGroup
          name="AdminSiteFeatures"
          renderAs="hlist"
          styleOverrides={{
            menu: " mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6",
          }}
          skipRootItem
          menuItemRender={(item) => {
            if (item.name === "AdminUpdates") {
              item.addOn = () => {
                if (!updates) return null
                return (
                  <div className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-admin_error text-white text-md font-medium -mt-1 -mr-1">
                    {updates > 99 ? "99+" : updates}
                  </div>
                )
              }
            }
            return <FeatureCard {...item} />
          }}
        />
      </div>
    </div>
  )
}

export default Admin